import { render, staticRenderFns } from "./AvsStep.vue?vue&type=template&id=2463f9ad"
import script from "./AvsStep.vue?vue&type=script&lang=js"
export * from "./AvsStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports